import { render, staticRenderFns } from "./PriceListCard.vue?vue&type=template&id=80822d86&"
import script from "./PriceListCard.vue?vue&type=script&lang=js&"
export * from "./PriceListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports